<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Funding records')}}</div>
        </div>
        <div class="detail_box">
            <van-empty :description="$t('item.noData')" v-if="listShow" />
            <van-cell-group inset>
                <van-cell v-for="item in recordList" center :title="item.name" :value="item.amount" :label="item.create_time" />
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "records",
        data() {
            return {
                listShow: false,
                recordList: [],
            }
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                Fetch('/user/futureList').then(r => {
                    this.recordList = r.data.records;
                    this.recordList.forEach(item => {
                        if (item.type === 1) {
                            item.name = this.$t('Transfer In');
                        } else if (item.type === 2) {
                            item.name = this.$t('Transfer Out');
                        } else if (item.type === 3) {
                            item.name = this.$t('Daily income');
                        }
                    });
                    this.showError(r.data.records.length);
                })
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            },
        },
    }
</script>

<style lang="less" scoped>
    .red_top_bg {
        /*height: 126px;*/
        background: #99c999;
        position: fixed;
    }
    .detail_box {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 66px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 14px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 20px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
</style>